/* eslint-disable no-shadow */
/* eslint-disable import/prefer-default-export */
export enum THEME {
  DARK = 'dark',
  LIGHT = 'light'
}
